import React from 'react';
import cn from 'classnames';

import {
  TypographySize,
  TypographyWeight,
  TypographyColor,
  TypographyTag
} from './types';
import styles from './Typography.module.scss';

export type TypographyProps = {
  size?: TypographySize;
  color?: TypographyColor;
  weight?: TypographyWeight;
  children: React.ReactNode;
  className?: string;
  tag?: TypographyTag;
} & React.HTMLAttributes<HTMLElement>;

const Typography: React.FC<TypographyProps> = ({
  size = TypographySize.s,
  color = TypographyColor.primary,
  weight = TypographyWeight.normal,
  children,
  className,
  tag: Component = TypographyTag.div,
  ...rest
}) => {
  return (
    <Component
      className={cn(
        styles['typography'],
        styles[`typography_size_${size}`],
        styles[`typography_color_${color}`],
        styles[`typography_weight_${weight}`],
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default React.memo(Typography);
